module.exports = __webpack_public_path__ + "static/media/fifteenth_cleo_rogers_memorial_library6.3fc904d8.png";